/**
 * Convert PCM ArrayBuffer to Base64 string for transmission
 */
export function pcmBufferToBase64(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}

/**
 * Decode Base64 Gemini audio response to Float32Array for Web Audio API
 * Gemini returns audio/pcm;rate=24000 (Int16 PCM)
 */
export function decodeGeminiAudio(base64Data: string): Float32Array {
  const binaryString = atob(base64Data);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  // Convert bytes to Int16Array (PCM format)
  const pcmData = new Int16Array(bytes.buffer);

  // Convert to Float32 for Web Audio API (normalize to [-1, 1])
  const float32Data = new Float32Array(pcmData.length);
  for (let i = 0; i < pcmData.length; i++) {
    float32Data[i] = pcmData[i] / 32768.0;
  }

  return float32Data;
}

/**
 * Calculate audio level from Float32 samples (0-100)
 */
export function calculateAudioLevel(samples: Float32Array): number {
  let sum = 0;
  for (let i = 0; i < samples.length; i++) {
    sum += Math.abs(samples[i]);
  }
  return Math.min((sum / samples.length) * 100 * 5, 100);
}
